module.exports = __webpack_public_path__ + "assets/img/desk.d0554e77.jpg";